export default __webpack_public_path__ + "static/media/Ethereum-ETH-icon.23ca4a5f.png";